const locale = {
    placeholder: 'Pasirinkite laiką',
    rangePlaceholder: ['Pradžios laikas', 'Pabaigos laikas'],
};
export default locale;
